function subtract(value, other) {
    return value - other;
}

export { subtract };
